import { createLazyComponent, LazyModule } from 'owa-bundling';
export { ComponentClass } from 'react';
export { HipCheckModalProps } from './types/HipCheckModalProps';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "OwaHipCheckModal" */ './lazyIndex')
);

export const HipCheckModal = createLazyComponent(lazyModule, m => {
    return m.HipCheckModal;
});
